// 実績の出所（source）を表示用ラベルに変換する。
// MCP 経由で接続したサービスは DCR で名乗った名前から source が自動導出されるため、
// 既知ラベルに無い source もそのまま（読みやすく整形して）表示する＝新規サービスに自動対応。

const KNOWN_SOURCE_LABELS: Record<string, string> = {
  claude: 'Claude',
  shift_senshi: 'shiftRG',
  'skt-sebas': '就活セバス',
}

/** 表示すべき出所ラベルを返す。手動登録・空は null（バッジ非表示）。 */
export function sourceBadgeLabel(source: string | null | undefined): string | null {
  if (!source || source === 'manual') return null
  if (KNOWN_SOURCE_LABELS[source]) return KNOWN_SOURCE_LABELS[source]
  // 未知 source（自動導出スラグ）はハイフンを空白にし先頭を大文字化して表示
  return source.replace(/-/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}
